import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';
import JournalCategory from '../../../../components/templates/journal/journalCategory';

const JournalTagTastic = ({ data, tastic, context, isServerSideRendering }) => {
  const isSSR = typeof isServerSideRendering === 'boolean' && isServerSideRendering;
  const content = data?.blogTagData;
  const categories = content?.topCategories ?? [];
  const tag = content?.tag ?? null;
  const articlesCollection = content?.articlesCollection ?? {};


  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <JournalCategory
      isSSR={isSSR}
      sectionName
      categories={categories}
      title={tag?.title}
      description={tag?.shortDescription}
      backgroundColor={tag?.backgroundColor}
      pageTitle={tag?.title}
      activeSlug={tag?.slug}
      articles={articlesCollection?.items}
      total={articlesCollection?.total}
      teaser={tag?.teaser}
      banner={tag?.topBanner}
      paginationState={{
        limit: articlesCollection?.limit,
        skip: articlesCollection?.skip,
        total: articlesCollection?.total,
      }}
    />
  );
};

export default tastify({
  translate: true,
  connect: {
    tastic: true,
    context: true,
    isServerSideRendering: true,
  },
})(JournalTagTastic);
